import {Stack} from "@mui/material";
import {LoginCard} from "../components/login-card";

export const LoginPage = () => (
    <Stack direction="column" alignItems="center" justifyContent="center">
        <LoginCard />
    </Stack>
);